import React from "react"
import Modal from "aldoo-ra/Modal"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import Spinner from "aldoo-ra/Spinner"
import TextBundle from "aldoo-ra/CMS/text-bundle"

export default function DeleteModal({ confirmDelete, selectedCount, isDeleting, onCancel, onConfirm }) {
  const texts = TextBundle({ id: "transfer_share_dashboard" })
  return (
    <Modal variant="meet_compact" isOpen={!!confirmDelete} onClose={onCancel}>
      <div className="p-6 w-full text-center">
        <Typography variant="h4" className="mb-2">
          {texts?.deleteShareTitle}
        </Typography>
        <Typography variant="body" className="text-text_secondary mb-6">
          {confirmDelete === "selected"
            ? `${texts?.delete} ${selectedCount} ${texts?.deleteSelectedSuffix}`
            : `${texts?.delete} "${confirmDelete?.share?.file_name}"? ${texts?.deleteSingleSuffix}`}
        </Typography>
        <div className="flex gap-2 justify-center">
          <Button onClick={onCancel} variant="secondary" className="flex-1" disabled={isDeleting}>
            {texts?.cancel}
          </Button>
          <Button onClick={onConfirm} variant="secondary_red" className="flex-1" disabled={isDeleting}>
            {isDeleting ? <Spinner className="w-[16px] h-[16px]" /> : texts?.delete}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
